module.exports = __webpack_public_path__ + "static/media/male-front-pecs-pecs.7167f250.png";